var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', _vm._b({
    attrs: {
      "label": "ECO No"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.ECO_NO,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "ECO_NO", $$v);
      },
      expression: "form.bom.ECO_NO"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1)], 1), _c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1)], 1), _c('v-divider'), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', _vm._b({
    attrs: {
      "label": "품번"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.MODEL_CODE,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "MODEL_CODE", $$v);
      },
      expression: "form.bom.MODEL_CODE"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-lg-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', _vm._b({
    attrs: {
      "label": "품명"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.MODEL_NAME,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "MODEL_NAME", $$v);
      },
      expression: "form.bom.MODEL_NAME"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-lg-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', _vm._b({
    attrs: {
      "label": "Rev."
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.REVISION,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "REVISION", $$v);
      },
      expression: "form.bom.REVISION"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-lg-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('form-table-row', _vm._b({
    attrs: {
      "label": "Rank"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.RANK,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "RANK", $$v);
      },
      expression: "form.bom.RANK"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1)], 1)], 1), _c('v-divider'), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', _vm._b({
    attrs: {
      "label": "시방 일자"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    attrs: {
      "type": "date"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.ECO_DATE,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "ECO_DATE", $$v);
      },
      expression: "form.bom.ECO_DATE"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-lg-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', _vm._b({
    attrs: {
      "label": "적용일자(시작)"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    attrs: {
      "type": "date"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.DATE_FR,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "DATE_FR", $$v);
      },
      expression: "form.bom.DATE_FR"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-lg-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', _vm._b({
    attrs: {
      "label": "적용일자(종료)"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    attrs: {
      "type": "date",
      "value": "2099-12-31"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.DATE_TO,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "DATE_TO", $$v);
      },
      expression: "form.bom.DATE_TO"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-lg-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  })], 1), _c('v-divider'), !_vm.isCreate ? [_c('form-table-row', _vm._b({
    attrs: {
      "label": "변경사유"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-text-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.bom.ECO_REASON,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "ECO_REASON", $$v);
      },
      expression: "form.bom.ECO_REASON"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))], 1), _c('form-table-row', _vm._b({
    attrs: {
      "label": "상세내역"
    },
    model: {
      value: _vm.form.bom.ECO_DETAIL,
      callback: function callback($$v) {
        _vm.$set(_vm.form.bom, "ECO_DETAIL", $$v);
      },
      expression: "form.bom.ECO_DETAIL"
    }
  }, 'form-table-row', Object.assign({}, _vm.attrs__row), false), [_c('v-textarea', _vm._b({
    attrs: {
      "rows": "2"
    },
    on: {
      "input": _vm.emit
    }
  }, 'v-textarea', Object.assign({}, _vm.attrs__field), false))], 1)] : _vm._e(), _c('mes-bom-rows-form', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'mes-bom-rows-form', {
    isCreate: _vm.isCreate
  }, false))], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }